<template>
  <div id="app">
    <the-header />
    <main class="main" :class="$route.name">
      <the-map />
      <the-overlay />
    </main>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheMap from "@/components/TheMap.vue";
import TheOverlay from "@/components/TheOverlay.vue";

export default {
  name: "App",
  components: {
    TheHeader,
    TheMap,
    TheOverlay,
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("loadEntreprises");
  },
};
</script>

<style lang="scss">
@import "./assets/styles/style.css";
#app {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

main.main {
  position: relative;
  flex: 1 0 0;
  width: auto;
  height: 100%;
  overflow: hidden;
}

/**********
TRANSITIONS
**********/

// Fade
.fade-enter {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter-active {
  transition: opacity 0.3s;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}
.fade-leave-active {
  transition: opacity 0.3s;
}

// Slide
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.8s var(--ExpoEaseOut);
}
.slide-enter, .slide-leave-to /* .fade-leave-active in <2.1.8 */ {
  transform: translate3d(-100%, 0, 0);
}

// Tabs : Slide + Fade
.tabs-enter {
  opacity: 0;
  transform: translate3d(0, 10px, 0);
}
.tabs-enter-to {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
.tabs-enter-active {
  transition: opacity 0.2s, transform 0.2s ease;
}
.tabs-leave {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
.tabs-leave-to {
  opacity: 0;
  transform: translate3d(0, -10px, 0);
}
.tabs-leave-active {
  transition: opacity 0.2s, transform 0.2s ease;
}
</style>
